import React, { useState } from "react"
import { useFormik } from "formik"
import * as Yup from "yup"
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { UserServices } from "../../services/user/user.services";
import { addUser } from "../../redux/user/userslice";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";
import { getVersion } from "../../utility";

const LoginComponent = () => {
    const [showPassword, setShowPassword] = useState(false)
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const formik = useFormik({
        initialValues: {
            email: "",
            userPassword: "",
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .email('Please enter a valid email address')
                .required('Email is required'),
            userPassword: Yup.string()
                .min(4, "Password should be at least 4 characters")
                .required("Password is required"),
        }),
        onSubmit: async (values, { resetForm }) => {
            try {
                const response = await UserServices.login(values.email, values.userPassword);
                // console.log("Login response:", response);

                if (response?.data) {
                    // const loggedInUser = response.data;
                    const loggedInUser = {
                        ...response.data,
                        userRole: response.data?.role?.roleName ?? "",
                        role: response.data?.role ?? null, // 👈 preserve original role
                    };
                    // console.log("Logged-in User Details:", loggedInUser);

                    dispatch(addUser(loggedInUser));

                    localStorage.setItem("isLoggedIn", "true");
                    localStorage.setItem("userDetails", JSON.stringify(loggedInUser));

                    handleNotify("Login successful!", TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
                    navigate("/dashboard");
                    resetForm();
                } else {
                    handleNotify("Invalid email or password.", TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
                }
            } catch (error) {
                console.error("Login error:", error);

                if (
                    error?.response?.status === 400 &&
                    error?.response?.data?.errorDetails?.message
                ) {
                    const messages = error.response.data.errorDetails.message;
                    messages.forEach((msg) =>
                        handleNotify(msg, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT)
                    );
                } else {
                    handleNotify("Something went wrong during login.", TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
                }
            }
        }
    })

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev)
    }

    return (
        <>
            <div className="section-authentication-signin d-flex align-items-center justify-content-center my-2">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-8 col-md-6 col-lg-4">
                            <div className="card mb-0">
                                <div className="card-body">
                                    <div className="p-4" style={{ border: "2px solid #f1f1f1", borderRadius: "8px" }}>
                                        <div className="text-center mb-4">
                                            <h3>Sign in</h3>
                                            <form className="row g-3" onSubmit={formik.handleSubmit}>
                                                <div className="col-12">
                                                    <label htmlFor="email" className="form-label d-flex">
                                                        Email Address<span className="text-danger">*</span>:
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="email"
                                                        className={`form-control ${formik.touched.email && formik.errors.email ? "is-invalid" : ""}`}
                                                        id="email"
                                                        placeholder="example@gamil.com"
                                                        value={formik.values.email}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.email && formik.errors.email && (
                                                        <div className="invalid-feedback d-flex">{formik.errors.email}</div>
                                                    )}
                                                </div>
                                                <div className="col-12 mb-3">
                                                    <label htmlFor="password" className="form-label d-flex">
                                                        Enter Password<span className="text-danger">*</span>:
                                                    </label>
                                                    <div className="input-group">
                                                        <input
                                                            type={showPassword ? "text" : "password"}
                                                            className={`form-control ${formik.touched.userPassword && formik.errors.userPassword ? "is-invalid" : ""}`}
                                                            id="userPassword"
                                                            name="userPassword"
                                                            placeholder="Enter Your Password"
                                                            value={formik.values.userPassword}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.userPassword && formik.errors.userPassword && (
                                                            <div className="invalid-feedback d-flex">{formik.errors.userPassword}</div>
                                                        )}

                                                        <button type="button" className="input-group-text bg-transparent" onClick={togglePasswordVisibility}>
                                                            <i className={`bx ${showPassword ? "bx-hide" : "bx-show"}`} />
                                                        </button>
                                                        {formik.touched.userPassword && formik.errors.password && (
                                                            <div className="invalid-feedback d-flex">{formik.errors.password}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="text-center">
                                                        <button type="submit" className="btn btn-primary" > Sign in </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <small className="text-center"> {getVersion()} </small>
        </>
    );
};

export default LoginComponent;